/** The visible slice of the screen. A phone keyboard shrinks this and may offset it. */
export interface VisualViewportBox {
  height: number;
  offsetTop: number;
}

/**
 * Place a PIN dialog in the area that is still on screen.
 * `layoutHeight` is the fallback when the browser has not reported a visual viewport yet.
 */
export function pinDialogFrame(viewport: VisualViewportBox | null, layoutHeight: number): VisualViewportBox {
  if (!viewport || viewport.height <= 0) return { offsetTop: 0, height: Math.max(layoutHeight, 1) };
  return { offsetTop: Math.max(0, viewport.offsetTop), height: viewport.height };
}

/** Keep the focused PIN field inside the dialog once the keyboard has opened. */
export function scrollPinFieldIntoView(node: HTMLElement): void {
  node.scrollIntoView({ block: 'center', inline: 'nearest' });
}
